import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/clock.png'
import _imports_1 from '@/assets/img/aliPay.png'
import _imports_2 from '@/assets/img/aliPayCode.png'
import _imports_3 from '@/assets/img/wechatPay.png'
import _imports_4 from '@/assets/img/wechatPayCode.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-c854306e")

_pushScopeId("data-v-c854306e")
const _hoisted_1 = { class: "pay-order" }
const _hoisted_2 = { class: "timer" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "img" }, [
  /*#__PURE__*/_createVNode("img", { src: _imports_0 })
], -1)
const _hoisted_4 = {
  key: 0,
  class: "time"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 剩余支付时间 ")
const _hoisted_6 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_7 = {
  key: 1,
  class: "time"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 已超时，订单取消 ")
const _hoisted_9 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 无法支付 ")
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "warn" }, [
  /*#__PURE__*/_createTextVNode(" 逾期订单自动取消 "),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" 请尽快支付 ")
], -1)
const _hoisted_12 = { class: "right" }
const _hoisted_13 = { class: "pay-way" }
const _hoisted_14 = { class: "choice" }
const _hoisted_15 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_16 = {
  key: 0,
  class: "code",
  src: _imports_2,
  alt: "二维码无法显示"
}
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "separator" }, null, -1)
const _hoisted_18 = { class: "choice" }
const _hoisted_19 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_20 = {
  key: 0,
  class: "code",
  src: _imports_4,
  alt: "二维码无法显示"
}
const _hoisted_21 = { class: "pay-bottom" }
const _hoisted_22 = { class: "money" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" 订单总金额： ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.maxtime > 0)
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            _hoisted_5,
            _hoisted_6,
            _createTextVNode(" " + _toDisplayString(_ctx.time), 1)
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_7, [
            _hoisted_8,
            _hoisted_9,
            _hoisted_10
          ])),
      _hoisted_11
    ]),
    _createVNode("div", _hoisted_12, [
      _createVNode("div", _hoisted_13, [
        _createVNode("div", _hoisted_14, [
          _createVNode("img", {
            class: "button-img ali",
            src: _imports_1,
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.ali && _ctx.ali(...args)))
          }),
          _hoisted_15,
          (_ctx.aliPay)
            ? (_openBlock(), _createBlock("img", _hoisted_16))
            : _createCommentVNode("", true)
        ]),
        _hoisted_17,
        _createVNode("div", _hoisted_18, [
          _createVNode("img", {
            class: "button-img wechat",
            src: _imports_3,
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.wechat && _ctx.wechat(...args)))
          }),
          _hoisted_19,
          (_ctx.wechatPay)
            ? (_openBlock(), _createBlock("img", _hoisted_20))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode("div", _hoisted_21, [
        _createVNode("div", _hoisted_22, [
          _hoisted_23,
          _createVNode("span", null, "￥" + _toDisplayString(_ctx.money), 1)
        ]),
        _createVNode("input", {
          type: "button",
          class: { overtime: _ctx.maxtime === 0 },
          value: "确认支付",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
        }, null, 2)
      ])
    ])
  ]))
})